import { Grid, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CustomLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  fontSize: '1.5rem',

  '&.active': {
    color: theme.palette.primary.title,
    textShadow: '0 0 2px rgba(110, 109, 109, 0.23)',
  },
  '&:hover': {
    color: theme.palette.primary.title,
    textShadow: '0 0 2px rgba(110, 109, 109, 0.23)',
  },
}));

export const CustomGrid = styled(Grid)(({ theme }) => ({
  marginLeft: '40px',
  [theme.breakpoints.down('md')]: {
    marginLeft: '0',
  },
  '& .MuiButton-outlined': {
    color: theme.palette.primary.title,
    borderColor: theme.palette.primary.title,
  },
  '& .MuiLink-root': {
    color: theme.palette.primary.titleShadow,
  },
}));
